import { IonSkeletonText } from '@ionic/react'

import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

function OutreachListSkeleton() {
  return (
    <div className="ml-3 flex">
      {Array(10)
        .fill(null)
        .map((_i, idx) => (
          <div key={idx} className="mr-3 w-36">
            <Card>
              <CardHeader>
                <CardTitle>
                  <IonSkeletonText
                    animated
                    style={{
                      '--background': 'rgba(0,0,0,.65)',
                      '--background-rgb': '0,0,0',
                    }}
                    className="m-0 size-full"
                  />
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="mx-auto mt-auto w-2/5 pt-2 text-center text-sm leading-none">
                  <IonSkeletonText
                    animated
                    style={{
                      '--background': 'rgba(0,0,0,.65)',
                      '--background-rgb': '0,0,0',
                    }}
                    className="m-0 size-full"
                  />
                </p>
              </CardContent>
            </Card>
          </div>
        ))}
    </div>
  )
}

export { OutreachListSkeleton }
